export class HomeConfigSlim {
  constructor(public home: string, public masterFile: string, public options: Array<string>) {
  }
}